module.exports = __webpack_public_path__ + "static/media/combo_ride_8.858ee2d3.png";